import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';

// FontAwesome.
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// Hooks.
import { useBreadcrumbsData } from 'app/client/components/Breadcrumbs/contexts/BreadcrumbsData';

// Styled.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as S from './styled';

const Breadcrumbs = () => {
  const { breadcrumbData } = useBreadcrumbsData();

  return (
    <S.Container>
      <S.Item key="home">
        <NavLink to="/">
          <FontAwesomeIcon icon={byPrefixAndName.fas.home} />
        </NavLink>
      </S.Item>
      {breadcrumbData.length > 0 && (
        <S.Icon key="chevron-home" icon={byPrefixAndName.fal['chevron-right']} size="xs" />
      )}
      {breadcrumbData.map(({ name, path }, index) => (
        <Fragment key={name}>
          {index > 0 && (
            <S.Icon key={`chevron-${name}`} icon={byPrefixAndName.fal['chevron-right']} size="xs" />
          )}
          <S.Item key={name}>{path ? <NavLink to={path}>{name}</NavLink> : name}</S.Item>
        </Fragment>
      ))}
    </S.Container>
  );
};

export default Breadcrumbs;
